// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"TemplatePage__ellipsis__ZPYMV","flex-child-ellipsis":"TemplatePage__flex-child-ellipsis__H_6NM","multiplayer-cursor":"TemplatePage__multiplayer-cursor__3m0iq"};